export enum ClvMessageType {
  INFO, SUCCESS, ERROR, WARNING
}
